import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { MoradorComRendaDto } from '@usucampeao/lib-reurb-simplificado';
import { LoadingService, ToastService } from '@usucampeao/ui-mobile';
import { finalize } from 'rxjs/operators';
import { CadastroService } from '../../../../state/cadastros.service';


@Component({
  selector: 'usucampeao-morador-com-renda-card',
  templateUrl: './morador-com-renda-card.component.html',
  styleUrls: ['./morador-com-renda-card.component.scss']
})
export class MoradorComRendaCardComponent {
  @Input() cadastroId: string;
  @Input() morador: MoradorComRendaDto;

  constructor(
    private readonly alertCtrl: AlertController,
    private readonly cadastrosService: CadastroService,
    private readonly loadingService: LoadingService,
    private readonly toastService: ToastService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) { }


  public irParaEdicao(): void {
    this.router.navigate([this.morador.cpf, 'editar'], { relativeTo: this.route })
  }

  public async cancelarProgramaSuperSocial() {
    const alert = await this.alertCtrl.create({
      header: 'Deletar informações do morador?',
      message: 'Deletar as informações do morador cadastrado?',
      buttons: [
        {
          text: 'Voltar',
          role: 'cancel',
        },
        {
          text: 'Deletar',
          cssClass: 'alert-button-danger',
          handler: async () => {
            await this.loadingService.createLoader();
            this.cadastrosService.removerMoradorComRenda(this.cadastroId, this.morador.cpf)
              .pipe(
                finalize(() => this.loadingService.dismiss()),
              )
              .subscribe({
                next: () => {
                  this.toastService.success('Morador removido com sucesso').toPromise();
                },
                error: error => {
                  this.toastService.error('Erro ao remover morador. Por favor tente novamente mais tarde.').toPromise();
                  throw error;
                }
              })
          }
        }
      ]
    });

    await alert.present();
  }
}
